<template>
  <div class="base-report report-shop-menu-sales">
    <div class="filter">
      <el-form inline>
        <el-date-picker
          v-model="searchForm.from_date"
          type="date"
          size="mini"
          placeholder="開始日"
          value-format="yyyy-MM-dd"
          :clearable="false">
        </el-date-picker>
        <el-date-picker
          v-model="searchForm.to_date"
          type="date"
          size="mini"
          placeholder="終了日"
          value-format="yyyy-MM-dd"
          :clearable="false">
        </el-date-picker>
        <el-button size="mini" type="primary" @click="fetchData" :disabled="isLoading">表示</el-button>
        <div style="float: right; padding-right: 20px;">
          <el-button v-show="$store.getters.isPC && screenData.length>0" size="mini" type="success" icon="el-icon-download" @click="exportCSV">ダウンロード</el-button>
        </div>
      </el-form>
    </div>
    <div class="table_data" v-loading="isLoading">
      <template v-if="screenData.length>0">
        <el-table
          :data="screenData"
          border
          stripe
          height="100%">
          <template v-for="(header, index) in tableSetting">
            <template v-if="!Array.isArray(header)">
              <el-table-column
                :key=header.prop
                :label=header.label
                :prop=header.prop
                :formatter="formatter"
                :fixed=header.fixed
                :align=header.align
                :sortable=header.sortable
                :min-width=header.width>
                <template v-if="Array.isArray(tableSetting[index + 1])">
                  <template v-for="(subheader, subindex) in tableSetting[index + 1]">
                    <el-table-column
                    :key="subheader.prop + subindex"
                    :label=subheader.label
                    :prop=subheader.prop
                    :min-width=subheader.width
                    :align=subheader.align
                    :sortable=subheader.sortable
                    :formatter="formatter">
                    </el-table-column>
                  </template>
                </template>
              </el-table-column>
            </template>
          </template>
        </el-table>
      </template>
      <div v-else v-show="noData">
        データがありません。<br>
        条件を変えて再度「表示」ボタンを押してください。
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import addFigure from '@/misc/addFigure.js'
import downloadCSV from '@/misc/downloadCSV.js'
import {mapGetters} from 'vuex'

export default {
  name: 'ReportShopMenuSales',
  data () {
    return {
      isLoading: false,
      noData: false,
      tableStatic: [
        {label: 'メニュー', prop: 'itemName', align: 'left', fixed: true, sortable: true, width: '130px'},
        {label: '単価', prop: 'unitPrice', align: 'right', sortable: true, width: '130px'},
        {label: '原価', prop: 'costPrice', align: 'right', sortable: true, width: '130px'},
        {label: '売上', prop: 'totalPrice', align: 'right', sortable: true, width: '130px'},
        {label: '売上（税抜）', prop: 'excludeTaxTotalPrice', align: 'right', sortable: true, width: '130px'},
        {label: '粗利益', prop: 'grossProfit', align: 'right', sortable: true, width: '130px'},
        {label: '合計', prop: 'count', align: 'right', sortable: true, width: '130px'},
      ],
      tableSetting: [],
      searchForm: {
        from_date: null,
        to_date: null,
      },
      screenData: [],
      orgData: [],
      totalData: [],
      form: {},
      csv_filename: '店舗別メニュー売上.csv',
    }
  },
  computed: {
    ...mapGetters('account', [
      'isGroupMode',
    ]),
  },
  watch: {
    isGroupMode (val) {
      if (!val) {
        this.$router.push({name: 'Home'})
      }
    },
  },
  methods: {
    fetchData () {
      this.isLoading = true
      this.noData = false
      this.screenData = []
      this.totalData = []
      this.orgData = []
      this.tableSetting = _.cloneDeep(this.tableStatic)

      this.$request.reports.shopMenuSales(this.searchForm.from_date, this.searchForm.to_date).then(res => {
        let data = res.body
        if (data.shopHeader) {
          this.addHeader(data.shopHeader)
        }

        if (data.records) {
          for (let record of data.records) {
            this.screenData.push(record)
          }
        }
      }, err => {
        const body = err.response.body
        this.$parent.$emit('requestError', [body])
        console.log(err)
      }).finally(() => {
        this.isLoading = false
      })
    },
    addHeader (headers) {
      for (let header of headers) {
        let code = header['uuid']
        let name = header['shopName']
        this.tableSetting.push({label: name, prop: code + 'Count', align: 'right', sortable: true, width: '80px'})
      }
    },
    exportCSV () {
      let header = []
      let keyList = []
      for (let tableHeader of this.tableSetting) {
        if (Array.isArray(tableHeader)) {
          let preHeader = header.pop()
          for (let subHeader of tableHeader) {
            if (subHeader.prop) {
              keyList.push(subHeader.prop)
            }
            header.push(`${preHeader}-${subHeader.label}`)
          }
        } else {
          if (tableHeader.prop) {
            keyList.push(tableHeader.prop)
          }
          header.push(tableHeader.label)
        }
      }
      let data = []
      for (let record of this.screenData) {
        let tmp = []
        for (let key of keyList) {
          tmp.push(this.formatData(key, record[key]))
        }
        data.push(tmp)
      }

      downloadCSV(this.csv_filename, header, data, this.totalData)
    },
    formatter (row, column) {
      let key = column.property
      return this.formatData(key, row[key])
    },
    formatData (key, value) {
      switch (key) {
        case 'itemName':
          return value
        default:
          return addFigure(Math.round(value))
      }
    },
  },
  mounted () {
    this.searchForm.from_date = moment().date(1).format('YYYY-MM-DD')
    this.searchForm.to_date = moment().format('YYYY-MM-DD')
//    this.fetchData()
  },
}
</script>

<style lang="sass">
@import "static/sass/report/common.sass"
</style>



// WEBPACK FOOTER //
// src/components/Report/ReportShopMenuSales.vue